export const verify3DSPayload = (mode, content) => {
  const result = [];

  if (!mode) return result;

  switch (mode) {
    case 'form': {
      if (!content?.action) {
        result.push('action url is absent for 3ds mode [form]');
      }

      break;
    }
    default:
      break;
  }

  return result;
};
